import React, { useState, useRef, useEffect } from "react";
import { NavLink } from 'react-router-dom';
import Logo from '../img/twicces.png';
import { FaBars } from "react-icons/fa";
const Navbar = () => {
  const [showLinks, setShowLinks] = useState(false);
  
  return (
    <header>
        <div id="twiceslogo"><img src={Logo} alt="Twice As Good Logo" /></div>
        <nav>
          <ul>
            <li>
                <NavLink  to="/" end className={({ isActive }) => ( isActive ? "active" : "link" )}>Home</NavLink>
            </li>
             <li>
                <NavLink to="/about" className={({ isActive }) => ( isActive ? "active" : "link" )}>About Us</NavLink>
            </li>
            <li>
                <NavLink to="/contact" className={({ isActive }) => ( isActive ? "active" : "link" )}>Contact</NavLink>
            </li>
          </ul>
        </nav>
        <div id="hamburger"  onClick={() => setShowLinks(!showLinks)}>
          <FaBars />
        </div>
        <ul className={`${showLinks? 'mobile-nav show-container': 'mobile-nav'}`}>
          <li>
                <NavLink  to="/" end className={({ isActive }) => ( isActive ? "active" : "link" )}>Home</NavLink>
            </li>
             <li>
                <NavLink to="/about" className={({ isActive }) => ( isActive ? "active" : "link" )}>About Us</NavLink>
            </li>
            <li>
                <NavLink to="/contact" className={({ isActive }) => ( isActive ? "active" : "link" )}>Contact</NavLink>
            </li>
        </ul>
    </header>
  );
};
export default Navbar;
